<template>
  <div class="user-edit-page" v-loading="loading">
    <div class="header-bar">
      <el-button type="primary" size="small" plain @click="goBack">
        <i class="el-icon-arrow-left"></i> 返回列表
      </el-button>
      <span class="page-title">编辑用户信息</span>
    </div>

    <div class="form-container">
      <!-- 基本信息卡片 -->
      <div class="section-card">
        <div class="section-header">
          <i class="el-icon-user"></i>
          <span>基本信息</span>
        </div>
        <el-form :model="userForm" ref="userForm" label-width="100px" class="edit-form">
          <el-form-item label="用户头像">
            <div class="avatar-preview">
              <el-image
                :src="getAvatarUrl()"
                fit="cover"
                class="avatar-image"
              >
                <div slot="placeholder" class="avatar-placeholder"></div>
                <div slot="error" class="avatar-error">
                  <i class="el-icon-user"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>

          <el-form-item label="用户昵称">
            <el-input
              v-model="userForm.nickname"
              placeholder="请输入用户昵称"
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item label="邮箱地址">
            <el-input
              v-model="userForm.email"
              placeholder="请输入邮箱地址"
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item label="手机号">
            <el-input
              v-model="userForm.phone"
              placeholder="请输入手机号"
              size="small"
            ></el-input>
          </el-form-item>

          <el-form-item label="用户积分">
            <el-input-number
              v-model="userForm.points"
              :min="0"
              :max="999999"
              size="small"
              :controls="false"
              class="points-input"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <!-- 认证信息卡片 -->
      <div class="section-card">
        <div class="section-header">
          <i class="el-icon-medal"></i>
          <span>医生认证</span>
        </div>
        <el-form :model="userForm" label-width="100px" class="edit-form">
          <el-form-item label="审核状态">
            <el-select v-model="userForm.isDoctorCertified" placeholder="请选择审核状态" size="small">
              <el-option label="未认证" :value="0"></el-option>
              <el-option label="审核中" :value="1"></el-option>
              <el-option label="已认证" :value="2"></el-option>
            </el-select>
            <div class="status-tips">
              <el-tag :type="getCertificationTagType(userForm.isDoctorCertified)" size="small" style="margin-left: 10px;">
                {{ getCertificationText(userForm.isDoctorCertified) }}
              </el-tag>
            </div>
          </el-form-item>

          <el-form-item label="认证图片">
            <div v-if="userForm.doctorCertificationImage" class="cert-image-container">
              <el-image
                :src="userForm.doctorCertificationImage"
                :preview-src-list="[userForm.doctorCertificationImage]"
                class="cert-image"
                fit="contain"
              >
                <div slot="error" class="cert-image-error">图片加载失败</div>
              </el-image>
            </div>
            <span v-else class="no-cert-tip">暂无认证图片</span>
          </el-form-item>
        </el-form>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <el-button @click="goBack" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm" size="small" :loading="submitting">
          <i class="el-icon-check"></i> 保存更改
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserPut, getUserView } from "@/api/user";

export default {
  name: "user-edit",
  data() {
    return {
      loading: false,
      submitting: false,
      userForm: {
        _id: '',
        nickname: '',
        email: '',
        phone: '',
        avatar: '',
        points: 0,
        isDoctorCertified: 0,
        doctorCertificationImage: ''
      },
    };
  },
  created() {
    this.fetchUserDetails();
  },
  methods: {
    getAvatarUrl() {
      const src = this.userForm && this.userForm.avatar ? String(this.userForm.avatar).trim() : '';
      if (!src) return '';
      try {
        const url = new URL(src, window.location.origin);
        url.searchParams.set('_t', String(Math.floor(Date.now() / 60000)));
        return url.toString();
      } catch (e) {
        return src;
      }
    },
    getCertificationTagType(status) {
      if (status === 2) return 'success';
      if (status === 1) return 'warning';
      return 'info';
    },
    getCertificationText(status) {
      if (status === 2) return '已认证';
      if (status === 1) return '审核中';
      return '未认证';
    },
    goBack() {
      this.$router.push({ name: "user" });
    },
    async fetchUserDetails() {
      this.loading = true;
      const userId = this.$route.query.userId;
      try {
        const res = await getUserView({ id: userId });
        if (res.status === '10000') {
          this.userForm = {
            ...this.userForm,
            ...res.data,
            isDoctorCertified: Number(res.data.isDoctorCertified) || 0,
            points: Number(res.data.points) || 0
          };
        } else {
          this.$message.error('获取用户信息失败');
        }
      } catch (error) {
        this.$message.error('获取用户信息失败');
      } finally {
        this.loading = false;
      }
    },
    async submitForm() {
      this.submitting = true;
      try {
        const param = {
          id: this.userForm._id,
          nickname: this.userForm.nickname,
          phone: this.userForm.phone,
          email: this.userForm.email,
          points: this.userForm.points,
          isDoctorCertified: this.userForm.isDoctorCertified,
        };
        const res = await getUserPut(param);
        if (res.status === '10000') {
          this.$message.success('用户信息已保存');
          setTimeout(() => {
            this.goBack();
          }, 500);
        } else {
          this.$message.error(res.message || '保存失败');
        }
      } catch (error) {
        this.$message.error('保存失败');
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.user-edit-page {
  background-color: #f5f7fa;
  min-height: 100%;
  padding: 20px;
  height: calc(100vh - 84px);
  overflow-y: auto;
}

/* 头部栏 */
.header-bar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 18px;
  font-weight: 500;
  color: #303133;
  margin-left: 16px;
}

/* 内容容器 */
.form-container {
  max-width: 720px;
  margin: 0 auto;
}

/* 分区卡片 */
.section-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 24px 24px 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.section-header i {
  margin-right: 8px;
  font-size: 18px;
  color: #409EFF;
}

/* 表单样式 */
.edit-form {
  padding: 0 8px;
}

.edit-form ::v-deep .el-form-item {
  margin-bottom: 22px;
}

.edit-form ::v-deep .el-form-item__label {
  font-weight: 400;
  color: #606266;
}

.edit-form ::v-deep .el-input__inner {
  border-radius: 4px;
}

.points-input ::v-deep .el-input__inner {
  text-align: left;
}

/* 头像预览 */
.avatar-preview {
  display: inline-block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #ebeef5;
}

.avatar-image {
  width: 100%;
  height: 100%;
}

.avatar-placeholder,
.avatar-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f3f5;
  color: #c0c4cc;
  font-size: 28px;
}

/* 状态提示 */
.status-tips {
  display: inline-block;
  margin-left: 8px;
}

/* 认证图片 */
.cert-image-container {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  max-width: 400px;
}

.cert-image {
  width: 100%;
  min-height: 120px;
  cursor: pointer;
}

.cert-image-error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 120px;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 14px;
}

.no-cert-tip {
  color: #909399;
  font-size: 14px;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 0;
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .user-edit-page {
    padding: 12px;
  }

  .form-container {
    max-width: 100%;
  }

  .section-card {
    padding: 16px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-buttons .el-button {
    width: 100%;
  }
}
</style>
